import { ensureSliderNav } from './slider-nav.js'

(function () {
    const escapeHtml = (value = '') => {
        return String(value).replace(/[&<>"']/g, (char) => {
            return ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;',
            })[char];
        });
    };

    function renderBlogItems(items = []) {
        if (!items.length) {
            return `
                <div class="slider-list-item">
                    <div class="list-item latest-ad">
                        <div class="list-item-content">
                            <div class="latest-blog-title">Bu kategoride henüz içerik yok.</div>
                        </div>
                    </div>
                </div>
            `;
        }

        return items.map((item) => `
            <div class="slider-list-item">
                <a href="${escapeHtml(item.url)}" class="list-item latest-ad">
                    <div class="list-item-photo">
                        <picture>
                            <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" />
                        </picture>
                    </div>

                    <div class="list-item-content">
                        <div class="latest-blog-info">
                            <time datetime="${escapeHtml(item.date_iso || '')}">
                                ${escapeHtml(item.date_text || '')}
                            </time>
                            <i></i>
                            <small>${Number(item.reading_minutes || 1)} dk</small>
                        </div>

                        <div class="latest-blog-title">${escapeHtml(item.title || '')}</div>
                    </div>
                </a>
            </div>
        `).join('');
    }

    function initBlogSlider($el) {
        if (!$el.length) return;
        if ($el.hasClass('slick-initialized')) return;

        $el.slick({
            dots: false,
            pauseOnHover: true,
            speed: 250,
            autoplay: false,
            swipeToSlide: true,
            slidesToShow: 4,
            appendArrows: ensureSliderNav($el[0]),
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    function destroyBlogSlider($el) {
        if (!$el.length) return;
        if ($el.hasClass('slick-initialized')) {
            $el.slick('unslick');
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const tabsRoot = document.getElementById('homeBlogTabs');
        if (!tabsRoot) return;

        const listNode = document.querySelector('[data-blog-list]');
        if (!listNode) return;

        const endpoint = tabsRoot.dataset.url || '';
        if (!endpoint) return;

        const $list = window.jQuery ? window.jQuery(listNode) : null;
        const categoryCache = new Map();
        let activeCategoryId = Number(tabsRoot.dataset.activeCategory || 0);
        let loading = false;
        let abortController = null;

        const setActiveTab = (categoryId) => {
            tabsRoot.querySelectorAll('[data-blog-category-tab]').forEach((tab) => {
                const tabId = Number(tab.dataset.categoryId || 0);
                tab.classList.toggle('active', tabId === Number(categoryId));
            });
        };

        const setLoading = (state) => {
            loading = state;
            listNode.style.pointerEvents = state ? 'none' : 'auto';
            tabsRoot.style.pointerEvents = state ? 'none' : 'auto';
        };
        const replaceSliderContent = (items) => {
            if ($list) {
                destroyBlogSlider($list);
            }

            listNode.innerHTML = renderBlogItems(items);

            if ($list) {
                initBlogSlider($list);
            }
        };

        const fetchBlogs = async (categoryId) => {
            if (loading) return;

            // cache varsa direkt bas
            if (categoryCache.has(categoryId)) {
                replaceSliderContent(categoryCache.get(categoryId));
                return;
            }

            if (abortController) {
                abortController.abort();
            }

            abortController = new AbortController();

            const url = new URL(endpoint, window.location.origin);
            url.searchParams.set('category_id', String(categoryId));
            url.searchParams.set('limit', '4');

            setLoading(true);

            try {
                const response = await fetch(url.toString(), {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    },
                    signal: abortController.signal
                });

                if (!response.ok) {
                    throw new Error('Blog verileri alınamadı');
                }

                const data = await response.json();
                const items = data.items || [];

                categoryCache.set(categoryId, items);
                replaceSliderContent(items);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    if (window.UI && typeof window.UI.toast === 'function') {
                        window.UI.toast('error', 'Hata', 'Bloglar yüklenirken bir sorun oluştu.');
                    } else {
                        console.error(error);
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        tabsRoot.addEventListener('click', function (event) {
            const tab = event.target.closest('[data-blog-category-tab]');
            if (!tab) return;

            event.preventDefault();

            const categoryId = Number(tab.dataset.categoryId || 0);
            if (!categoryId || categoryId === activeCategoryId) return;

            activeCategoryId = categoryId;
            setActiveTab(activeCategoryId);
            fetchBlogs(activeCategoryId);
        });

        setActiveTab(activeCategoryId);
    });
})();
